
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/account-admin-tools/jst/courseLoggingContent';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<h2>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("accounts.admin_tools.course_logging_content")
  },data:data},helper ? helper.call(depth0, "course_activity_bfe11267", "Course Activity", options) : helperMissing.call(depth0, "t", "course_activity_bfe11267", "Course Activity", options)))
    + "</h2>\n\n<div id=\"course_activity_form_mount_point\"></div>\n\n<hr aria-hidden=\"true\"/>\n\n<div id=\"courseLoggingSearchResults\"></div>\n\n<div id=\"course_activity_details_mount_point\"></div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  